export default __webpack_public_path__ + "static/media/mad-main.534a67d0.svg";